import React from 'react'
import * as Comp from './Components';
import { Section } from './Style';
const CourseTest = () => {
    return (
        <Section>
            <Comp.HeaderTest />
            <Comp.Questions />
        </Section>
    )
}

export default CourseTest